import { useState } from "react";
import {
  FiCheck, FiHome, FiShield,
  FiCoffee, FiSun, FiDroplet
} from "react-icons/fi";

const CATEGORIES = {
  "Salle de bain": ["douche", "serviettes", "toilettes", "papier", "sèche"],
  "Confort":       ["climatisation", "insonorisées", "familiales", "lit", "linge"],
  "Sécurité":      ["extincteurs", "caméras", "détecteurs", "alarme", "coffre"],
  "Extérieur":     ["mer", "terrasse", "extérieur", "jardin", "piscine"],
  "Services":      ["réception", "concierge", "bagagerie", "restaurant", "voiture", "change", "facture", "enregistrement", "départ", "diffusion"],
};

const ICONS = {
  "Salle de bain": FiDroplet,
  "Confort":       FiHome,
  "Sécurité":      FiShield,
  "Extérieur":     FiSun,
  "Services":      FiCoffee,
  "Autres":        FiCheck,
};

function getCategory(item) {
  const lower = item.toLowerCase();
  for (const [cat, keywords] of Object.entries(CATEGORIES)) {
    if (keywords.some((k) => lower.includes(k))) return cat;
  }
  return "Autres";
}

function groupEquipments(list) {
  const grouped = {};
  list.forEach((item) => {
    const cat = getCategory(item);
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(item);
  });
  return Object.entries(grouped).sort(([a], [b]) => {
    if (a === "Autres") return 1;
    if (b === "Autres") return -1;
    return 0;
  });
}

export default function HotelEquipments({ equipments = [] }) {
  const [showAll, setShowAll] = useState(false);
  const MAX = 12;

  const visible = showAll ? equipments : equipments.slice(0, MAX);
  const groups = groupEquipments(visible);
  const hasMore = equipments.length > MAX;

  return (
    <div className="w-full">

      {/* ── Header ───────────────────────────────────────────────── */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900">Équipements</h2>
        <p className="text-sm text-gray-400 mt-1">
          Services et équipements de l'établissement
        </p>
      </div>

      {/* ── Grille catégories ─────────────────────────────────────── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
        {groups.map(([category, items]) => {
          const Icon = ICONS[category] || FiCheck;
          return (
            <div
              key={category}
              className="bg-[#3A9D23]/5 rounded-2xl p-5"
            >
              {/* Category header */}
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-8 h-8 rounded-xl bg-[#3A9D23]/10 text-[#3A9D23] flex items-center justify-center shrink-0">
                  <Icon size={15} />
                </div>
                <h3 className="text-sm font-semibold text-gray-800">
                  {category}
                </h3>
              </div>

              {/* Items */}
              <ul className="flex flex-col gap-2.5">
                {items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <div className="w-4 h-4 rounded-full bg-white border border-gray-200 flex items-center justify-center shrink-0 mt-0.5">
                      <FiCheck size={10} className="text-[#3A9D23]" />
                    </div>
                    <span className="text-sm text-gray-600 leading-snug">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      {/* ── CTA voir plus ─────────────────────────────────────────── */}
      {hasMore && (
        <div className="mt-6">
          <button
            onClick={() => setShowAll(!showAll)}
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-gray-300 hover:shadow-sm transition"
          >
            {showAll
              ? "Réduire"
              : `Voir tous les équipements (${equipments.length})`}
          </button>
        </div>
      )}

    </div>
  );
}